import { computed, nextTick } from 'vue';
import { store } from '@/store';
import { btnMode as btnModeType } from '@/types/btnMode';
import { globalData } from '@/global';
import { useShare } from '@/hooks/useShare';
import { useTrack } from '@/hooks/useTrack';
import { useLogin } from '@/hooks/uselogin';
import toast from '@kk/toast';
import { useJoinTeam } from '@/hooks/useJoinTeam';
import { useUpdateTeamRank } from '@/hooks/useUpdateTeamRank';
import { useUpadeMainPageData } from '@/hooks/useUpadeMainPageData';
import { single } from '@/utils';
import { useOffline } from '@/hooks/useOffline';


import types from '@/store/types';
export function useBtn () {
  const { trackBtn } = useTrack();
  const doShare = useShare();
  const { clickLogin } = useLogin();
  const { showOffline, offlineToast } = useOffline();
  const shareCode = computed(() => store.state.shareCode);
  /**
   * 加入队伍可获得多少KK币
   */
  const joinShareAssistanceTeamCanObtain = computed(
    () => store.state.rule.joinShareAssistanceTeamCanObtain
  );
  /**
   * 按钮模式
   */
  const btnMode = computed<btnModeType>(() => {
    const isShare = store.state.isShare;
    const isKuaikan = globalData.isKuaikan;
    const isFull =
      store.state.currentMembers.length >= store.state.rule.teamMaxPerson;
    if (!isKuaikan) {
      // 不在快看
      return 'deeplink';
    } else {
      if (isShare) {
        // 受邀者视角
        if (isFull) {
          return 'full2join';
        } else {
          return 'join';
        }
      } else {
        // 发起者视角
        if (isFull) {
          return 'full';
        } else {
          if (store.state.currentMembers.length > 0) {
            return 'share';
          } else {
            return 'start';
          }
        }
      }
    }
  });
  /**
   * 按钮文案
   */
  const buttonText = computed(() => {
    let text = '';
    switch (btnMode.value) {
      case 'deeplink':
        text = '打开快看APP加入队伍即可免费看漫画';
        break;
      case 'join':
        text = `加入队伍即可获得${joinShareAssistanceTeamCanObtain.value}KK币`;
        break;
      case 'share':
        text = '召集新队员赚KK币';
        break;
      case 'start':
        text = '去组队赚KK币';
        break;
      case 'full':
        text = '本期队伍人数已满';
        break;
      case 'full2join':
        text = '队伍人数已满，重新组队';
        break;
    }
    return text;
  });
  /**
   * 显示加入队伍成功弹框
   */
  const showJoin = computed<boolean>({
    get: () => store.state.showJoin,
    set: (v) => store.commit(types.SET_SHOW_JOIN, v),
  });
  /**
   * 点击按钮
   * @param btnName 按钮名次，不填则为按钮显示名称
   */
  const clickBtn = single(
    async function clickBtn (btnName?: string) {
      trackBtn(btnName || buttonText.value);
      if (showOffline.value) {
        offlineToast('组队暂时下线，期待更好玩的组队活动吧');
        return;
      }
      if (btnMode.value === 'join') {
        try {
          loading.show();
          const res = await useJoinTeam(shareCode.value);
          if (res.code === 200) {
            showJoin.value = true;
            nextTick(async () => {
              useUpadeMainPageData();
              useUpdateTeamRank();
            });
          } else {
            toast.show({
              text: res.message || '服务器错误',
              time: 1500,
            });
            console.log(res.message);
            nextTick(async () => {
              useUpadeMainPageData();
              useUpdateTeamRank();
            });
          }
          loading.hide();
        } catch (e) {
          loading.hide();
          console.info('加入队伍失败', e);
        }
      } else if (btnMode.value === 'share' || btnMode.value === 'start') {
        if (clickLogin()) {
          doShare({
            title: '快看可以领币免费看漫画啦！快来跟我组队一起薅羊毛吧>V<',
            desc: '快看APP真的有超多好看的漫画，快来一起看呀~~',
            shareImage: `${process.env.VUE_APP_SHARE_IMAGE}`,
          });
        }
      } else if (btnMode.value === 'full2join') {
        location.replace(
          `${location.origin}${location.pathname}?&conf2scrollwhitearea=1&conf2fullscreen=1&statusbar=0`
        );
      }
    }
  );
  return { btnMode, buttonText, clickBtn, showJoin };
}
